/**
 * Manager who provide custom fields
 */

import Manager from '../../managers/Manager'
import EQError from '../../utils/EQError'

const AUTHORIZED_CUSTOM_FIELDS = ['mscore_custom_string_1', 'mscore_custom_string_2', 'mscore_custom_string_3',
    'mscore_custom_string_4', 'mscore_custom_string_5', 'mscore_custom_string_6', 'mscore_custom_string_7', 'mscore_custom_string_8',
    'mscore_custom_string_9', 'mscore_custom_string_10', 'mscore_custom_string_11', 'mscore_custom_string_12', 'mscore_custom_string_13',
    'mscore_custom_string_14', 'mscore_custom_string_15'];

export default class CustomFieldsManager extends Manager {

    constructor() {
        super();
        this.customFields = new Map();
    }

    /**
     * Set a new custom field
     *
     * @param key
     * @param value
     */
    add(key, value) {
        if (AUTHORIZED_CUSTOM_FIELDS.indexOf(key) >= 0) {
            this.customFields.set(key, value);
        } else {
            throw new EQError('Custom fields key unauthorized, use one of them: ' + AUTHORIZED_CUSTOM_FIELDS, 1900);
        }
    }

    /**
     * Delete a custom field
     *
     * @param key
     */
    delete(key) {
        if (AUTHORIZED_CUSTOM_FIELDS.indexOf(key) >= 0) {
            this.customFields.delete(key);
        } else {
            throw new EQError('Custom fields key unauthorized, use one of them: ' + AUTHORIZED_CUSTOM_FIELDS, 1901);
        }
    }

    /**
     * Returns a custom field for a specific key
     *
     * @param key
     * @returns {V}
     */
    get(key) {
        return this.customFields.get(key);
    }

    /**
     * Returns all custom fields
     *
     * @returns {Map}
     */
    getAll() {
        return this.customFields;
    }


}



// WEBPACK FOOTER //
// ./js/core/customfields/manager/CustomFieldsManager.js